import { db } from '../firebase'
import {
  collection,
  addDoc,
  query,
  where,
  getDocs,
  serverTimestamp,
} from 'firebase/firestore'

const STAGING_ADMIN_ID = '662934209aaa6eafeae2da7a'

async function fetchLiveAdmins() {
  const snaps = await getDocs(collection(db, 'admins'))
  return snaps.docs
    .map(d => ({ _id: d.id, ...d.data() }))
    .filter(a => a._id !== STAGING_ADMIN_ID)
}

export async function getOrCreateConvo(adminId, driverId, orderID = null) {
  // 1) Get all live-admin IDs (excluding the staging one)
  const admins = await fetchLiveAdmins()
  const adminIds = admins.map(a => a._id)

  // 2) Build the compositeKey from [ ...adminIds, driverId ] (sorted)
  const participants = [...adminIds, driverId].sort()
  const baseKey      = participants.join('_')
  const compositeKey = orderID
    ? `${baseKey}_${orderID}`
    : baseKey

  // 3) Try to find an existing conversation by compositeKey
  const convosRef = collection(db, 'conversations')
  const q = query(
    convosRef,
    where('compositeKey', '==', compositeKey)
  )
  const snap = await getDocs(q)
  if (!snap.empty) {
    return snap.docs[0].ref
  }

  // 4) Otherwise create a new one
  const newConvoData = {
    participants: [...adminIds, driverId],
    compositeKey,
    orderID:      orderID || null,
    lastMessage:  '',
    unreadCount:  0,
    createdAt:    serverTimestamp(),
    updatedAt:    serverTimestamp(),
  }
  const newRef = await addDoc(convosRef, newConvoData)
  return newRef
}
